import axios, { type AxiosRequestConfig } from 'axios';

type Methods = 'POST' | 'GET' | 'DELETE' | 'PUT';

export default async (
  method: Methods,
  url: string,
  data: any,
  headers: any,
): Promise<any> => {
  const options: AxiosRequestConfig = { method, url, data, headers };
  const res = await axios(options);

  return res;
};
